<template>
    <Modal :show-footer="false" :show-title="false" design="v3" @cancel="close">
        <div class="create-plan-information">
            <div class="svg-banner">
                <Discount />
            </div>
            <div class="discount">{{ $t("message.annualDiscountUpTo30") }}</div>
            <div class="description" v-if="planPeriod == 'monthly'">
                {{ $t("message.monthlyPlanAutoRenew") }}
            </div>
            <div class="description" v-else>
                {{ $t("message.yearlyPlanPrepaid") }}
            </div>
            <div class="important-note">
                {{ $t("message.prepaidPlanNote") }}
            </div>
            <div class="trial-note" v-if="isTrialMode">
                {{ $t("message.trialModeNote") }}
            </div>

            <div class="footer">
                <SupsisButton class="footer-btn" @click="close">İptal</SupsisButton>
                <SupsisButton class="footer-btn" primary @click="confirm">
                    <a-icon v-if="loading" type="loading" />
                    <span v-else>{{ planPeriod === 'monthly' ? $t("message.startSubscription") : $t("message.buyNow") }}</span>
                </SupsisButton>
            </div>
        </div>
    </Modal>
</template>
<script>
import Modal from "../common/Modal2.vue";
import Discount from "../svg/Discount.vue";
import { mapGetters } from "vuex";
import SupsisButton from "@/views/Pages/Settings/components/SupsisButton.vue";

export default {
    name: "CreatePlanModal",
    components: {
        Modal,
        Discount,
        SupsisButton,
    },
    props: {
        planPeriod: {
            type: String,
            default: "monthly",
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters({
            isTrialMode: "site/isTrialMode",
        }),
    },
    methods: {
        close() {
            this.$emit("reject");
        },
        confirm() {
            if (this.loading) return;
            this.$emit("confirm");
        },
    },
};
</script>
<style lang="scss">
.create-plan-information {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .discount {
        font-weight: bold;
        font-size: 18px;
        text-align: center;
        margin-top: 12px;
    }

    .description {
        font-size: 16px;
        margin-top: 10px;
        text-align: center;
    }

    .important-note {
        font-size: 14px;
        color: #666;
        margin-top: 16px;
        text-align: center;
        max-width: 520px;
        line-height: 1.6;
    }

    .trial-note {
        font-size: 14px;
        color: var(--color-text-default);
        margin-top: 12px;
        text-align: center;
        max-width: 420px;
        line-height: 1.5;
    }

    .subbutton {
        padding: 7px 20px;
        background: rgb(236, 75, 29);
        border-radius: 4px;
        font-size: 16px;
        cursor: pointer;
        color: white;
        margin-top: 25px;

        &:hover {
            background: rgb(252, 115, 77);
        }
    }

    .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        margin-top: 20px;
    }

    .footer-btn {
        min-width: 140px;
        height: 44px;
    }
}

.svg-banner {
    width: 200px;
    height: 170px;

    svg {
        width: 100%;
        height: 100%;
    }
}
</style>
